<template>
    <div>
        <div class="col-sm-12">
            <breadcrumbs v-if="forumTitle && $route.name !== 'course' "
                :breadcrumbs="[{title: 'Forum', link: '/forum'},{title: forumTitle, link: '/discussion/' + this.forumId }]">
            </breadcrumbs>
            <div class="panel">

                <div class="filters col-xs-12" v-if="categories.term.length > 0">


                    <div class="col-xs-3">
                        <select v-model="termFilter" class="form-control">
                            <option value="" default selected>Term</option>
                            <option
                                v-if="term.topic_count > 0"
                                v-for="term in categories.term"
                                :value="term.id">
                                {{term.name}}
                                ({{term.topic_count}})
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-4">

                        <select v-model="pathFilter" class="form-control">
                            <option value="" default selected>Path</option>
                            <option
                                v-for="path in categories.path"
                                v-if="path.topic_count > 0 && isInTerm(path.terms)"
                                :value="path.id">
                                {{path.name}}
                                ({{path.topic_count}})
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-4">
                        <select v-model="assignmentFilter" class="form-control">
                            <option value="" default selected>Assignment</option>
                            <option
                                v-if="assignment.topic_count > 0"
                                v-for="assignment in categories.assignment"
                                :value="assignment.id">
                                {{assignment.name}}
                                ({{assignment.topic_count}})
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-1 nopad">
                        <button @click.prevent="termFilter='';pathFilter='';assignmentFilter='';selectedTag=null" class="btn btn-success clear-filters">Clear Filters</button>
                    </div>

                </div>
                <div class="panel-heading"><h2>Threads<i class="clippie fa fa-info-circle" v-tooltip="'Threads within a sub-forum, sometimes specific to a course'"></i></h2></div>

                <div class="panel-body text-center noposts" v-if="!threads || threads.length === 0">
                    No posts yet
                </div>
                <div class="panel-body" v-else>
                    <ul class="threads clearfix" v-if="subforums">
                        <li class="clearfix forum-thread-header">
                            <div class="col-xs-1"></div>
                            <div class="col-xs-5">Title</div>
                            <div class="col-xs-3">Statistics</div>
                            <div class="col-xs-3">Last Post</div>
                            <div class="col-xs-1"></div>
                        </li>

                        <li
                            v-show="noFilter || isInFilter(thread.forum_categories)"
                            v-if="!selectedTag || isInTag(thread.forum_tags)"
                            v-for="thread in threads"
                            class="row thread clearfix">
                            <div class="avatar-wrapper col-xs-1">
                                <img :src="thread.poster.avatar" class="avatar-image">
                                <span class="sticky" v-if="thread.sticky===true">Sticky</span>
                            </div>
                            <div class="col-xs-5">
                                <span class="thread-name">
                                    <router-link :to="{ name: 'thread', params: { forumId: forumId, topicId: thread.id }}">
                                        {{thread.title | truncate(50)}}<br>
                                    </router-link></span>
                                by
                                <span class="post-author-link">
                                    <router-link :to="{ name: 'posts-by-user', query: { userId: thread.poster.id } }">
                                        <img :src="thread.poster.roles | roleIcon(thread.poster.terms)" class="role-icon">
                                        {{thread.poster.firstName}} {{thread.poster.lastName}}

                                    </router-link>
                                </span>

                                &raquo; {{thread.createdAt | shortDate}}

                                <div class="categories" v-if="thread.forum_categories.length > 0">Categories:
                                    <span v-for="(cat, $i) in thread.forum_categories">
                                        <span v-if="$i!=0">, </span>

                                        <span
                                            @click="setFilter(cat.type, cat.id)"
                                            :class="{'bold':termFilter===cat.id||pathFilter===cat.id||assignmentFilter===cat.id}"
                                            class="blue">{{cat.name}}
                                        </span>

                                    </span>
                                </div>
                                <div class="categories" v-if="thread.forum_tags.length > 0">Tags:

                                    <span v-for="(tag, $i) in thread.forum_tags">
                                        <span v-if="$i!=0">, </span>
                                        <span
                                            @click="selectedTag === tag.id ? selectedTag = null : selectedTag = tag.id"
                                            :class="{'bold': selectedTag === tag.id}"
                                            class="blue">{{tag.name | ucwords}}</span>
                                    </span>
                                </div>

                            </div>

                            <div class="stats-wrapper col-xs-3">
                                {{thread.post_count}} posts<br>
                                {{thread.views}} views
                                <span v-if="localStorage.roles.indexOf('Student') === -1 & localStorage.roles.indexOf('CampusStudent') === -1">
                                    <button @click="updateThread({sticky: true, id: thread.id})" v-if="!thread.sticky" class="btn btn-primary">Stick</button>
                                    <button @click="updateThread({sticky: false, id: thread.id})" v-if="thread.sticky" class="btn btn-primary">Unstick</button>
                                </span>
                            </div>
                            <div class="col-xs-3">
                                by
                                <span class="post-author-link">
                                    <router-link :to="{ name: 'posts-by-user', query: { userId: thread.latestPost.poster.id } }">
                                        <img :src="thread.latestPost.poster.roles | roleIcon(thread.latestPost.poster.terms)" class="role-icon">
                                        {{thread.latestPost.poster.firstName}} {{thread.latestPost.poster.lastName}}<br>

                                    </router-link>
                                </span>
                                {{thread.latestPost.createdAt | timeago}}

                            </div>

                        </li>
                    </ul>
                    <ul class="forum-pagination" v-if="totalPages > 1">
                        <li><a class="previous-page" href="#" @click.prevent="setPage(currentPage - 1)">&laquo;</a></li>

                        <li v-for="i in totalPages">
                            <a href="#"
                                @click.prevent="currentPage = (i - 1)"
                                :class="{'current-page': i === (currentPage+1)}">
                                {{i}}
                            </a>
                        </li>

                        <li><a class="previous-page" href="#" @click.prevent="setPage(currentPage + 1)">&raquo;</a></li>

                    </ul>
                </div>
            </div>

            <div class="panel new-thread">
                <div class="panel-heading"><h2>Post New Thread<i class="clippie fa fa-info-circle" v-tooltip="'Add a new thread to this sub-forum below.'"></i></h2></div>

                <div class="panel-body">
                    <form @submit.prevent="postTopic()">
                        <div class="form-group">
                            <input class="form-control" type="text" v-model="topic.title" placeholder="Title">
                        </div>


                        <div v-if="localStorage.roles.indexOf('Student') > -1" class="form-group col-sm-12 nopad categories" >
                            <label>Categories</label>
                            <div class="col-sm-4">
                                <select
                                    :class="{'placeholder': selectedCategories.term === ''}"
                                    class="form-control"
                                    placeholder="Term"
                                    v-model="selectedCategories.term">
                                    <option value="" default disabled>Term</option>
                                    <option v-for="term in categories.term" :value="term.id">
                                        {{term.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4" v-if="selectedTermType !== 'foundation'">
                                <select :class="{'placeholder': selectedCategories.path === ''}" class="form-control"  v-model="selectedCategories.path">
                                    <option value="" default>Learning Path</option>
                                    <option v-for="path in categories.path" :value="path.id">
                                        {{path.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4">
                                <select :class="{'placeholder': selectedCategories.assignment === ''}" class="form-control"
                                    v-model="selectedCategories.assignment">
                                    <option value="" default>Assignment</option>
                                    <option
                                        v-if="canSeeAssignment(assignment)"
                                        v-for="assignment in categories.assignment"
                                        :value="assignment.id">
                                        {{assignment.name}}
                                    </option>
                                </select>
                            </div>
                        </div>


                        <div class="form-group">
                            <label>Tags</label>
                            <input id="tags" @keydown.enter.prevent="addTag()" type="text" class="form-control" placeholder="Type a tag and press Enter or select one from the list">
                            <typeahead v-model="newTag" ref="typeahead" target="#tags" match-start :data="tags" item-key="name">

                                <template slot="item" scope="props">
                                    <li v-for="(item, index) in props.items" :class="{active:props.activeIndex===index}">
                                        <a role="button" @click="pushTag(item); newTag=null">
                                            {{item.name | ucwords}}
                                        </a>
                                    </li>
                                </template>

                            </typeahead>
                        </div>


                        <ul class="post-tags clearfix">
                            <li v-for="(tag, $index) in postTags">{{tag.name | ucwords}}<span class="remove" @click="postTags.splice($index,1)">x</span></li>
                        </ul>

                        <div class="form-group">
                            <vue-html5-editor @change="updateContent" :content="content" :height="200"></vue-html5-editor>

                        </div>
                        <div class="form-group">
                            <input type="submit" class="btn btn-success" value="Submit">
                        </div>
                    </form>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import router from '../router';

    import discussions from '../services/discussions';
    import discussionPost from './reusable/discussion/DiscussionPost';
    import breadcrumbs from './widgets/ForumBreadcrumbs.vue';
    import { Typeahead } from 'uiv'

    import _ from 'underscore';
    import toastr from 'toastr';

    export default {
        props: ['courseId'],
        name: 'discussions',

        data() {
            return {
                model:'', // TODO: unused?
                subforums: [], // TODO: unused?
                currentPage: 0,
                totalPages: null,
                selectedSubForum: null,
                instanceId: null,
                selectedPost: null,
                threads:null,
                userId: null,
                forumTitle: null,
                tags: [],
                newTag: null,
                postTags: [],
                selectedTag: null,
                categories:{
                    term: [],
                    path: [],
                    assignment:[]
                },
                selectedCategories: {
                    term: '',
                    path: '',
                    assignment: ''
                },
                termFilter:'',
                pathFilter: '',
                assignmentFilter: '',
                filters: {
                    term:'',
                    path:'',
                    assignment:''
                },
                topic: {
                    title:'',
                    body:'',
                    categoryId: null
                },
                reply: {
                    body: ''
                }
            }
        },

        components: {
            'discussion-post': discussionPost,
            breadcrumbs,
            Typeahead
        },

        mounted() {
            var self = this;

            if (this.$route.params.forumId) {
                this.forumId = this.$route.params.forumId;
                this.getTopics();
            } else {
                discussions.getSubForums(this, this.$route.params.courseId).then(function(response) {
                    self.forumId = response.data[0].id;
                    self.getTopics();
                });
            }

            if (this.$route.query.filter_type) {
                this.setFilter(this.$route.query.filter_type, this.$route.query.filter_id)
            }

            if (this.$route.query.tag) {
                this.selectedTag = this.$route.query.tag;
            }

            this.getCategories();
            this.getTags();
        },

        methods: {
            openTagList() {
                this.$refs.typeahead.open = true;
            },
            pushTag(tag) {
                let alreadyTagged = this.postTags.findIndex(function(t) { return t.id === tag.id});
                if (alreadyTagged === -1) {
                    this.postTags.push(tag);
                }
            },
            addTag() {
                var self = this;
                let tags = self.newTag;

                if (tags.indexOf(',') > -1) tags = tags.split(','); else tags = [tags];

                tags.forEach(function(tag) {
                    tag = tag.toLowerCase().trim();

                    let exists = self.tags.findIndex(function(t) { return t.name == tag});
                    self.newTag = null;
                    if (exists === -1) {
                        discussions.createTag(self, tag).then(function(response) {
                            self.tags.push(response.data.tag);
                            self.postTags.push(response.data.tag);
                        });
                    } else {
                        setTimeout(function() {
                            document.getElementById('tags').value = '';
                        },200);
                        let alreadyTagged = self.postTags.findIndex(function(t) { return t.id === self.tags[exists].id});
                        if (alreadyTagged === -1) {
                            self.postTags.push(self.tags[exists]);
                        }
                    }
                })

            },
            getTags() {
                var self = this;
                discussions.getTags(this).then(function(response) {
                    self.tags = response.data.tags;
                });
            },
            setFilter(type, id){
                this.termFilter = '';
                this.pathFilter = '';
                this.assignmentFilter = '';
                let filter = type + 'Filter';
                this[filter] = id;
            },
            canSeeAssignment(assignment) {
                var self = this;
                if (this.selectedTermType === 'foundation' && assignment.termType === 'foundation') return true;
                let i = this.categories.path.findIndex(function(p) { return p.id === self.selectedCategories.path});
                if (i === -1) return false;
                return assignment.paths.indexOf(parseInt(this.categories.path[i].associatedId)) > -1;
            },
            isInTerm(terms) {
                var self = this;
                if (this.termFilter === '') return true;
                let index = this.categories.term.findIndex(function(t) { return t.id === self.termFilter });
                if (terms.indexOf(this.categories.term[index].associatedId) > -1) {
                    return true;
                }
                return false;
            },
            isInPath(assignment) {
                var self = this;

                if (this.termFilter === '' && this.pathFilter === '') return false;

                if (this.termFilter !== '') {
                    let j = this.categories.term.findIndex(function(t) { return t.id === self.termFilter});
                    let termType = this.categories.term[j].termType;

                    if (assignment.termType === 'foundation' && termType === 'foundation') return true;
                }
                if (this.pathFilter !== '') {
                    let j = this.categories.path.findIndex(function(t) { return t.id === self.pathFilter});
                    let path = parseInt(this.categories.path[j].associatedId);
                    if (assignment.paths.indexOf(path) > -1) return true;
                }

                return false;


            },
            isInFilter(categories) {
                if (this.assignmentFilter === '' && this.pathFilter === '' && this.termFilter === '') return true;

                var termFilter = false;
                var pathFilter = false;
                var assignmentFilter = false;

                if (this.assignmentFilter === '') { assignmentFilter = true; }
                else {
                    let assignment = categories.filter(function(c) { return c.type === 'assignment'})[0];
                    if (assignment && this.assignmentFilter === assignment.id) {
                        assignmentFilter = true;
                    }
                }

                if (this.pathFilter === '') { pathFilter = true; }
                else {
                    let path = categories.filter(function(c) { return c.type === 'path'})[0];
                    if (path && this.pathFilter === path.id) {
                        pathFilter = true;
                    }
                }


                if (this.termFilter === '') { termFilter = true; }
                else {
                    let term = categories.filter(function(c) { return c.type === 'term'})[0];
                    if (term && this.termFilter === term.id) {
                        termFilter = true;
                    }
                }


                return termFilter === true && pathFilter === true && assignmentFilter === true;

            },
            isInTag(tags) {
                tags = tags.map(function(t) { return t.id });
                return tags.indexOf(this.selectedTag) > -1;
            },
            setPage(page) {
                if (page < 0 || page >= this.totalPages) return;
                this.currentPage = page;
            },
            getCategories() {
                var self = this;
                discussions.getCategories(this, this.forumId).then(function(response) {

                    if (response.data.success === true) {
                        let cats = response.data.categories;

                        cats.forEach(function(cat) {
                            self.categories[cat.type].push(cat);
                        });

                        let currentTerm = self.$store.getters.currentTerm.type;
                        let index = self.categories.term.findIndex(function(t) { return t.termType == currentTerm})

                        self.selectedCategories.term = self.categories.term[index].id;

                        if (localStorage.path && localStorage.path !== 'null') {
                            index = self.categories.path.findIndex(function(p) { return p.associatedId == localStorage.path});
                            self.selectedCategories.path = self.categories.path[index].id;
                        }

                    } else {
                        toastr.error('Error getting categories');
                    }
                })
            },
            updateContent(content) {
                this.topic.body = content;
            },
            updateThread(data) {
                var self = this;
                discussions.updateTopic(this, data).then(function() {
                    self.getTopics();
                });
            },
            getTopics(subforum, userId) {
                var self = this;
                if (this.$route.name !== 'videoPlayer') {
                    self.$store.dispatch('toggle',{type:'loading', boolean: true});
                }
                if (subforum) self.selectedSubForum = subforum;
                discussions.get(this, this.forumId, this.currentPage).then(function(response) {

                    self.threads = response.data.threads;
                    self.totalPages  = Math.ceil(response.data.count / 10);
                    self.forumTitle = response.data.forumTitle;
                    self.$store.dispatch('toggle',{type:'loading', boolean: false});
                });

            },
            postTopic() {
                var self = this;
                self.$store.dispatch('toggle',{type:'loading', boolean: true});

                let categories = Object.keys(this.selectedCategories)
                                       .map(function (key) { return self.selectedCategories[key]; })
                                       .filter(function(i) { return i !== null && i !== ''});

                let tags = this.postTags.map(function(t) { return t.id });
                let body = this.topic.body.replace(/ttto-discussion-images-full/g, 'ttto-discussion-images');

                var topic = {
                    title: this.topic.title,
                    body: body,
                    categories: categories,
                    forumId: self.forumId,
                    tags: tags
                }

                if (!topic.title || !topic.body) {
                    toastr.error('Please enter a topic and a message');
                    self.$store.dispatch('toggle',{type:'loading', boolean: false});
                    return;
                }
                if (!topic.title.length > 254) {
                    toastr.error('Title is too long');
                    self.$store.dispatch('toggle',{type:'loading', boolean: false});
                    return;
                }

                discussions.post(this, topic).then(function(response) {
                    if (response.success === false) {
                        toastr.error(response.message);
                    } else {
                        if (self.$route.name !== 'videoPlayer') {
                            self.$router.push('/thread/' + self.forumId + '/' + response.data.topicId);
                        } else {
                            self.getTopics();
                        }
                    }
                });
            },
        },

        watch: {
            '$route': function() {
                var self = this;
                if (this.$route.params.courseId) {
                    discussions.getSubForums(this, this.$route.params.courseId).then(function(response) {
                        self.forumId = response.data[0].id;
                        self.getTopics();
                    });
                }

            },
            currentPage(page) {
                if ( (page < 0) || (page >= this.totalPages)) {
                    return;
                } else {
                    this.getTopics(this.forumId);
                }
            }
        },

        computed: {
            noFilter() {
                let filters =  this.termFilter === '' && this.pathFilter === '' && this.assignmentFilter === '';

            },
            selectedTermType() {
                let self = this;
                let t = self.selectedCategories.term;
                if (t) {
                    let index = this.categories.term.findIndex(function(t) { return t.id === self.selectedCategories.term})
                    return this.categories.term[index].termType;
                }
            },
        },
    }

</script>

<style lang="scss">
    .forum-pagination {
        //width:90%;
        margin: 0 auto 2rem auto;
        //display:flex;
        //justify-content:space-around;
        text-align: center;
        .current-page, a {
            background: #363636;
            color:#fff;
        }
        a:hover {
            background:#4a4a4a;
            color:#33ccff;
            border-color:#999;
        }
        .current-page {
            text-decoration: underline;
            //background:#ccc;
            //color:black;
            border-color:#ccc;
        }
        .next-page, .previous-page {
            background: #363636;
            //color:#fff!important;
        }
        a {
            border:1px solid #1c1c1c;
            width:5rem;
            padding:1rem;
            margin: 0 1rem;
            display:inline-block;
            text-align: center;
            box-shadow: 0px 0px 5px rgba(0,0,0,.2);
        }
        li {
            display: inline-block;
        }
    }

    .dropdown.open .dropdown-menu {
        background: #222;
        opacity: 1;
        z-index: 99999999999999;
    }

    .panel .post-tags {
        width:100%;
        display:flex;
        flex-wrap: wrap;
        align-items:space-around;
        justify-content:flex-start;
        margin-bottom:1rem;
        li {
            background: #33ccff;
            color:#222;
            float:left;
            width:auto;
            padding: .5rem 1rem;
            margin:1rem;
            position: relative;
            .remove {
                color:#fff;
                display:inline-block;
                font-style:normal;
                background:#575757;
                border-radius:50%;
                position: absolute;
                top:-.5rem;
                right:-.5rem;
                cursor: pointer;
                font-weight:100;
                width:1.5rem;
                height:1.5rem;
                font-size:1.5rem;
                text-align:center;
                line-height: 1.2rem;
            }
        }
    }
</style>


<style lang="scss" scoped>
    .categories {
        & > label {
            display:block;
        }
        & > div:first-child {
            padding-left:0;
        }
        & > div:last-child {
            padding-right:0;
        }
        select.placeholder {
            color:#b0b0b0;
        }
    }
    .stats-wrapper {
        .btn {
            float:right;
        }
    }

    .new-thread .panel-body {
        padding:20px;
    }

    table {
        table-layout: fixed;
    }

    .new-thread {
        margin-top:2rem;
    }

    a {
        color:inherit;
    }

    li {
        padding:.5rem 0;
    }

    .header {
        background:#363636;
        z-index: 999999;
        position:relative;
    }

    .thread {
        background:#1c1c1c;
        margin-bottom:1rem;
        word-break: break-word;
        img {
            //margin-top:5px;
        }
    }

    .forum-thread-header {
        background: #666;
        color: white;
        display: block;
        //margin-top: 17px;
        height: 40px;
        padding-top: 11px;
        max-width: 97%;
        margin: 0 auto;
    }


    .threads li.thread {
        //background: #2c2c2c;
        margin-bottom: 1rem;
        padding-bottom: 0;
        margin-left:20px;
        margin-right:20px;
        display:flex;
        flex-direction:row;
        & > div:not(.avatar-wrapper) {
            padding-left:1rem;
            padding-right:1rem;
        }
    }

    .threads li.thread .stats-wrapper {
        border-left: 1px solid #1c1c1c;
        border-right: 1px solid #1c1c1c;
        background-color: #333;
        top:-2px;
        padding:.5rem;
    }

    .thread-name {
        a {
            font-weight:300;
            color: white;
            font-size:18px;
        }
    }

    .post-author-link {
        a {
            color:#33ccff;
        }
    }

    .avatar-image {
        object-fit: cover;
        height:100%;

        width: 100%;
    }

    .avatar-wrapper {
        padding:0!important;
        overflow: hidden;
        top:-5px;
        position:relative;
        height:100%;
        .sticky {
            background:transparentize(orange,.35);
            font-size:14px;
            position:absolute;
            top:0;
            left:0;
            color:#fff;
            text-transform: uppercase;
            padding: 0 5px
        }
        //max-height:
    }

    .disabled {
        background:transparent;
        background-image:none;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-indent: 1px;
        text-overflow: '';
    }
    .disabled::after {
        display:none;
    }

    .filters {
        padding: 0 0 1rem 0;
        & > div:first-child {
            padding-left:0;
        }
        & > div:last-child {
            padding-right:0;
        }
    }

    .categories, .tags {
        font-size:12px;
        clear:both;
        .blue {
            color:#33ccff;
            cursor: pointer;
        }
    }

    .noposts {
        padding:1rem!important;

    }

    .bold {
        font-weight: 700
    }

    .clear-filters {
        font-size:12px;
        padding:5px;
        margin-top:15px;
    }
</style>



// WEBPACK FOOTER //
// Discussion.vue?09180ba6